import styled, { css } from 'styled-components';
import { Button, Text } from 'up-ops-web-shared-components/lib';
import theme from 'up-ops-web-shared-components/lib/styles/theme';

export const ContentBoundary = css`
  margin: 0 auto;
  max-width: 1200px;
  padding-left: 3rem;
  padding-right: 3rem;
  width: 100%;
`;

export const FormRow = styled.div`
  display: flex;
  justify-content: center;

  & > * {
    flex: 1;
  }

  & > * + * {
    margin-left: 1rem;
  }

  & + & {
    margin-top: 2rem;
  }
`;

export const FormSubmitButton = styled(Button)`
  display: block;
  margin: 2rem auto;
  padding-left: 4rem;
  padding-right: 4rem;
  text-transform: uppercase;
`;

export const SectionHeader = styled.h2`
  color: ${(props) => props.theme.colors.textDark};
  font-size: 1.5rem;
  margin: 0.5rem 0;
`;

export const UnorderedList = styled.ul`
  list-style: none;
  list-style-position: inside;
  margin: 0;
  padding: 0;

  li + li {
    margin-top: 6px;
  }
`;

export const UploadHint = styled(Text)`
  color: inherit;
  display: block;
  font-size: ${(props) => props.theme.font.size.xs.fontSize};

  b {
    font-weight: ${(props) => props.theme.font.weight.medium};
  }
`;

export const UploadHintList = styled.ul`
  list-style-position: inside;
  margin: 0;
  padding: 0 0 0 0.5em;
`;

export const UpperCased = styled.b`
  text-transform: uppercase;
`;

export const Note = styled(Text)`
  color: inherit;
  background-color: ${theme.colors.backgroundPrimaryAccent};
  display: block;
  padding: 1rem 0 1rem 1rem;
  margin-top: 1rem;
`;
